import { all, call } from "redux-saga/effects";

import watchAppSaga from "./app";

export function* liveCasinoSaga() {
  yield all([
    call(watchAppSaga),
  ]);
}
